import { useCallback, useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useDispatch } from "react-redux";

import { searchCard } from "../../../../redux/SearchSlice";

export function useUserManagementHeader() {
  const dispatch = useDispatch();
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const debouncedSearch = useRef(
    _.debounce((value) => {
      dispatch(searchCard(value));
    }, 300)
  ).current;

  const openFilterDrawer = useCallback(() => {
    setIsFilterDrawerOpen(true);
  }, []);

  const closeFilterDrawer = useCallback(() => {
    setIsFilterDrawerOpen(false);
  }, []);

  const handleSearchChange = useCallback(
    (event) => {
      const value = event.target.value.trimStart();
      setSearchValue(value);
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
      dispatch(searchCard(""));
    };
  }, [debouncedSearch, dispatch]);

  return {
    searchValue,
    isFilterDrawerOpen,
    setIsFilterDrawerOpen,
    openFilterDrawer,
    closeFilterDrawer,
    handleSearchChange,
  };
}
